// import {
//     required,
//     numeric,
//     isNotZero,
// } from '../../mixins/reusable_mixins/InputValidations'
import MdlCommissionType from '../../models/Sale/SlCommissionType'

export default [
    {
        name: 'name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Nombre',
            // rules: [required],
        },
    },
    {
        name: 'description',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Descripción',
            // rules: [required],
        },
    },
    {
        name: 'percentage',
        type: 'float-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Porcentaje',
            suffix: '%',
            // rules: [required, numeric, isNotZero],
        },
    },
    {
        name: 'sl_commission_type_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            chips: false,
            itemText: 'type',
            itemValue: 'id',
            label: 'Tipo',
            model: MdlCommissionType,
            noDataText: 'Sin tipos.',
            noObject: true,
            paramSearch: 'type',
            // rules: [required],
        },
    },
]
